var _text;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgAv(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 15,
    height: 17,
    viewBox: "0 0 15 17",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _text || (_text = /*#__PURE__*/React.createElement("text", {
    fill: "#707070",
    fontFamily: "OpenSans-Semibold, Open Sans",
    fontSize: "12px",
    fontWeight: 600,
    letterSpacing: "-0.02em",
    transform: "translate(0 13)"
  }, /*#__PURE__*/React.createElement("tspan", {
    x: 0,
    y: 0
  }, "AV"))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAv);
export default __webpack_public_path__ + "static/media/AV.e668f18ccb608f8f0c237ee87ccb3d86.svg";
export { ForwardRef as ReactComponent };